import React, { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from 'shared/constants/messages';
import { LEVELS, createNotification } from 'shared/utilities/notification';
import { addNotification, setPageSize } from '../../core/redux/ui/actions';
import Select from 'react-select';
import { DebounceInput } from 'react-debounce-input';
import { switchDeviceAccount } from 'core/api/deviceOperations';
import PageListWrapper, {
  PageListHead,
  PageListSubTitle,
  PageListTitle,
  SearchBox,
} from 'shared/styles/components/PageList';
import ButtonWithLoader from 'shared/ui/buttons/ButtonWithLoader';
import { useEffect } from 'react';
import LoadingOverlay from 'shared/ui/spinners/LoadingOverlay';

const MigrateDevice = ({ envList, showSwitchNotification }) => {
  const [switchAccount, setSwitchAccount] = useState({ label: 'Dev', envName: 'Dev', value: 'Dev' });
  const [switchDeviceId, setSwitchDeviceId] = useState(null);
  const [switchingAccount, setSwitchingAccount] = useState(false);
  const dispatch = useDispatch();

  const styles = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      minWidth: '280px',
      maxWidth: '280px!important',
      minHeight: 'unset',
      display: 'flex',
      height: '35px',
      borderRadius: 0,
      border: '1px solid lightgrey',
      boxShadow: 'unset',
      '&:hover': {
        borderColor: 'gray',
      },
    }),
  };

  const submitDeviceId = async () => {
    setSwitchingAccount(true);
    await switchDeviceAccount({ deviceId: switchDeviceId, env: switchAccount.value.toLowerCase() })
      .then(() => {
        showSwitchNotification(LEVELS.SUCCESS, SUCCESS_MESSAGES.DEVICE_SWITCH);
        setSwitchingAccount(false);
      })
      .catch((e) => {
        console.log(e);
        showSwitchNotification(LEVELS.ERROR, ERROR_MESSAGES.DEVICE_SWITCH);
        setSwitchingAccount(false);
      });
  };

  return (
    <PageListWrapper>
      {envList.length === 0 ? <LoadingOverlay /> : null}
      <PageListHead migrate>
        <PageListTitle>Migrate Device</PageListTitle>
      </PageListHead>
      <PageListSubTitle migrate>
        <p>For internal testing use only.</p>
      </PageListSubTitle>
      <div style={{ display: 'flex' }}>
        <div>
          <div className="show-label" style={{ marginBottom: '5px' }}>
            VSG ID:
          </div>
          <SearchBox accountSwitch={true}>
            <DebounceInput
              type="text"
              className="search search-input"
              placeholder="Please enter VSG ID"
              onChange={(e) => setSwitchDeviceId(e.target.value)}
            />
          </SearchBox>
        </div>
        <div style={{ width: '250px', marginLeft: '20px' }}>
          <div className="show-label" style={{ marginBottom: '5px' }}>
            Select Account:
          </div>
          <Select
            placeholder="Select Account"
            style={styles}
            value={switchAccount}
            name="account"
            options={envList.filter(
              (d) => (d.value === 'Dev') & (d.envName === 'Dev') || d.envName === 'Staging' || d.envName === 'Prod'
            )}
            onChange={(e) => {
              setSwitchAccount(e);
            }}
            defaultValue={{ label: 'Dev', value: 'dev' }}
            hideSelectedOptions={false}
          />
        </div>
        <div style={{ margin: '23.5px 20px' }}>
          <ButtonWithLoader
            disabled={!switchDeviceId || switchDeviceId === undefined || switchDeviceId === ''}
            isLoading={switchingAccount}
            confirmText={'Submit'}
            loadingStyleProp={'submittingWithSpinner'}
            notLoadingStyleProp={'Submit'}
            clickHandler={submitDeviceId}
            acountForm={true}
          />
        </div>
      </div>
    </PageListWrapper>
  );
};

export default connect(
  (state) => ({
    isError: state.deviceOperations?.isError,
    envList: state.user.envList,
    deviceId: state?.deviceOperations?.deviceId,
  }),
  (dispatch) => ({
    showSwitchNotification: (type, message) =>
      dispatch(
        addNotification({
          notification: createNotification(type, message),
        })
      ),
  })
)(MigrateDevice);
